import React from "react";
import t, {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {GetPasswordRegex} from "../../../components/UtilsForFormValidation";
import {
  GetCurrentLocale,
} from "../../../components/Utils";
import {allCountries} from "../../../components/Countries";
import {
  renderEmailWithPattern,
  renderInputText,
  renderSelect,
  renderCheckbox, getSelectFromValue, renderInputNumber,
} from "../../../components/Forms/FormsComponent";

interface ComponentProps {
  register: any
  isEditForm: boolean
  notAuthentificatedInCart: any,
  errors: any,
  userAccount: any
  requiredField: any
  password: any
  userAccountLastName: any
  userAccountFirstName: any
  userAccountEmail: any
  userAccountPhoneNumber: any
  userAccountNatRegNum: any
  userAccountJobDepartment: any
  userAccountFax: any
  userAccountJobFunction: any
  userAccountCompanyName: any
  useraccountTaxNumber: any
  userAddressStreet: any
  userAddressZip: any
  userAddressCity: any
  userAccountSubscribedNewsletter: any,
  currentLocale: any
  setSelectedCountry: any
  userAddresses: any
  selectedCountry: any
}

const AccountForm: React.FC<ComponentProps> = ({register,
                                                 isEditForm,
                                                 notAuthentificatedInCart,
                                                 errors,
                                                 userAccount,
                                                 requiredField,
                                                 password,
                                                 userAccountLastName,
                                                 userAccountFirstName,
                                                 userAccountEmail,
                                                 userAccountPhoneNumber,
                                                 userAccountNatRegNum,
                                                 userAccountJobDepartment,
                                                 userAccountFax,
                                                 userAccountJobFunction,
                                                 userAccountCompanyName,
                                                 useraccountTaxNumber,
                                                 userAddressStreet,
                                                 userAddressZip,
                                                 userAddressCity,
                                                 userAccountSubscribedNewsletter,
                                                 currentLocale,
                                                 setSelectedCountry,
                                                 userAddresses,
                                                 selectedCountry
}:ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale);

  const countries = React.useMemo(() => allCountries(locale), []);

  React.useEffect(() => {
    const firstAddress = userAddresses?.[0];
    if (selectedCountry === null && firstAddress?.countryCode) {
      setSelectedCountry(getSelectFromValue(firstAddress.countryCode, countries));
    }
  }, [userAddresses]);

  return (
    <>
      <div className="col-md-12 mb-2">
        <h4>{t('personal_info')}</h4>
      </div>
      <div className="col-md-6 col-sm-12 mb-3">
        {
          renderInputText(t('name'), "lastName", errors.lastName, register, true, isEditForm, userAccountLastName)
        }
        {errors.lastName?.type === "required" &&
          <span className="invalid-feedback">{t("fields_required")}</span>}
      </div>
      <div className="col-md-6 col-sm-12 mb-3">
        {
          renderInputText(t('firstname'), "firstName", errors.firstName, register, true, isEditForm, userAccountFirstName)
        }
        {errors.firstName?.type === "required" &&
          <span className="invalid-feedback">{t("fields_required")}</span>}
      </div>
      <div className="col-md-6 col-sm-12 mb-3">
        {
          renderEmailWithPattern(t('email'), register, "email", true, errors.email, isEditForm, userAccountEmail)
        }
        {errors.email ? errors.email.type === 'pattern' ?
          <span className="invalid-feedback">{t("invalid_address")}</span> :
          <span className="invalid-feedback">{t("fields_required")}</span> : null}
      </div>
      <div className="col-md-6 col-sm-12 mb-3">
        {
          renderInputText(t('phone'), "phoneNumber", errors.phoneNumber, register, false, isEditForm, userAccountPhoneNumber)
        }
      </div>
      <div className="col-md-6 col-sm-12 mb-3">
        {
          renderInputText(t('national_registration_num'), "nationalRegistrationNumber", errors.nationalRegistrationNumber, register, true, isEditForm, userAccountNatRegNum)
        }
        {errors.nationalRegistrationNumber?.type === "required" &&
          <span className="invalid-feedback">{t("fields_required")}</span>}
      </div>
      {
        !notAuthentificatedInCart ?
          <>
            <div className="col-md-6 col-sm-12 mb-3">
              {
                renderInputText(t('department'), "jobDepartment", errors.jobDepartment, register, false, isEditForm, userAccountJobDepartment)
              }
            </div>
            <div className="col-md-6 col-sm-12 mb-3">
              {
                renderInputText(t('fax'), "fax", errors.fax, register, false, isEditForm, userAccountFax)
              }
            </div>
            <div className="col-md-6 col-sm-12 mb-3">
              {
                renderInputText(t('function'), "jobFunction", errors.jobFunction, register, false, isEditForm, userAccountJobFunction)
              }
            </div>
          </>
          :
          <>
            <div className="col-md-6 col-sm-12 mb-3">
              {
                renderSelect(currentLocale, t('country'), "countryCode", setSelectedCountry, true, countries, selectedCountry)
              }
              {errors.country?.type === "required" &&
                <span className="invalid-feedback">{t("fields_required")}</span>}
            </div>
          </>
      }
      {
        !isEditForm && !notAuthentificatedInCart ?
          <>
            <div className="col-md-6 col-sm-12 mb-3">
              <label htmlFor="password" className="required-field">{t('password')}</label>
              <input type="password"
                     className={errors.password ? "form-control is-invalid" : "form-control"}
                     id="password"
                     placeholder="●●●●●●●●"
                     {...register("password", {
                       validate: requiredField,
                       pattern: GetPasswordRegex()
                     })}
              />
              {errors.password ? errors.password.type === 'pattern' ?
                <span className="invalid-feedback">{t("conditions_pwd")}</span> :
                <span className="invalid-feedback">{t("fields_required")}</span> : null}
            </div>
            <div className="col-md-6 col-sm-12 mb-3">
              <label htmlFor="passwordConfirm" className="required-field">{t('confirm_password')}</label>
              <input type="password"
                     className={errors.passwordConfirm ? "form-control is-invalid" : "form-control"}
                     id="passwordConfirm"
                     placeholder="●●●●●●●●"
                     {...register("passwordConfirm",
                       {
                         required: !isEditForm,
                         validate: (value: any) =>
                           value === password.current || "The passwords do not match"
                       })}
              />
              {errors.passwordConfirm ? errors.passwordConfirm.type === 'validate' ?
                <span className="invalid-feedback">{t("password_no_match")}</span> :
                <span className="invalid-feedback">{t("fields_required")}</span> : null}
            </div>
          </>
          : null
      }
      <div className="col-md-6 col-sm-12 mb-3">
        <label className="hidden-visible">{t('register_to_newsletter')}</label>
        {
          renderCheckbox(t('register_to_newsletter'), "subscribedToNewsletter", false, register, isEditForm, userAccountSubscribedNewsletter)
        }
      </div>
      <div className="row width100">
        <hr/>
        <div className="col-md-12 mt-1 mb-5">
          <h4>{t('company_info')}</h4>
        </div>
        <div className="col-md-6 col-sm-12 mb-3">
          {
            renderInputText(t('company_name'), "companyName", errors.companyName, register, true, isEditForm, userAccountCompanyName)
          }
          {errors.companyName?.type === "required" &&
            <span className="invalid-feedback">{t("fields_required")}</span>}
        </div>
        {
          !notAuthentificatedInCart ?
            <>
              <div className="col-md-6 col-sm-12 mb-3">
                {
                  renderInputText(t('num_tva'), "taxNumber", errors.taxNumber, register, true, isEditForm, useraccountTaxNumber)
                }
                {errors.taxNumber?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
            </>
            : null
        }
      </div>
      {
        !isEditForm ?
          <>
            <div className="col-md-6 col-sm-12 mb-3">
              {
                renderInputText(t('address'), "street", errors.street, register, true, isEditForm, userAddressStreet)
              }
              {errors.street?.type === "required" &&
                <span className="invalid-feedback">{t("fields_required")}</span>}
            </div>
            <div className="col-md-6 col-sm-12 mb-3">
              {
                renderInputText(t('zip'), "zip", errors.zip, register, true, isEditForm, userAddressZip)
              }
              {errors.zip?.type === "required" &&
                <span className="invalid-feedback">{t("fields_required")}</span>}
            </div>
            <div className="col-md-6 col-sm-12 mb-3">
              {
                renderSelect(currentLocale, t('country'), "countryCode", setSelectedCountry, true, countries, selectedCountry)
              }
              {errors.country?.type === "required" &&
                <span className="invalid-feedback">{t("fields_required")}</span>}
            </div>
            <div className="col-md-6 col-sm-12 mb-3">
              {
                renderInputText(t('city'), "city", errors.city, register, true, isEditForm, userAddressCity)
              }
              {errors.city?.type === "required" &&
                <span className="invalid-feedback">{t("fields_required")}</span>}
            </div>
          </>
          : null
      }

    </>
  )
}

export default AccountForm;
